import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

export const AOJSlider = withStyles({
    root: {
        color: '#6fbf98',
        height: 2,
    },
    thumb: {
        height: 35,
        width: 15,
        borderRadius: 0,
        backgroundColor: '#fff',
        boxShadow: "inset 0 1px 0 rgb(255 255 255 / 80%), 0 1px 2px rgb(0 0 0 / 80%)",
        marginTop: -15,
        marginLeft: -14,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inset 0 1px 0 rgb(255 255 255 / 80%), 0 1px 2px rgb(0 0 0 / 80%)',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: "inset 0 1px 0 rgb(255 255 255 / 80%), 0 1px 2px rgb(0 0 0 / 80%)",
            },
        },
    },
    active: {},
    valueLabel: {},
    track: {
        height: 15,
        backgroundImage: "linear-gradient(to left, #075d34 0%, #6fbf98 100%)",
        boxShadow: "inset 0 -1px 0 rgb(0 0 0 / 15%)",
        borderRadius: 0,
        marginTop: -7
    },
    rail: {
        height: 15,
        backgroundImage: "linear-gradient(to bottom, #BBF1D7 0%,#BBF1D7 100%)",
        boxShadow: "inset 0 1px 2px rgb(0 0 0 / 10%)",
        borderRadius: 0,
        opacity: 1,
        marginTop: -7
    },
    mark: {
        opacity: 0,
    },
    markLabel: {
        color: '#333',
        fontSize: 13,
        marginTop: 10,
        marginLeft: -6,
        fontFamily: "'Raleway', sans-serif",
        textAlign: "center"
    },
})(Slider);
